export default __webpack_public_path__ + "static/media/icon-crawl.0fd36da3.svg";